import { useRef, useState } from "react";
import { useAuth } from "src/context";
import { useClickOutsideModalListener } from "src/hooks/useClickOutsideModalListener";
import { useNavigate } from "react-router-dom";
import {
  Container,
  Header,
  MonogrammedDetailContainer,
  DetailContainer,
  NameLabel,
  ActionItem,
  EmailLabel,
  Divider,
  Row,
  RowIcon,
  RowLabel,
} from "./UserOptionSelector.styles";
import { FoldIcon, UnfoldIcon, LogoutIcon } from "src/assets/icons";
import Monogram from "src/components/Monogram";

interface UserOptionSelectorProps {
  isDrawerCollapsed: boolean;
}

export default ({ isDrawerCollapsed }: UserOptionSelectorProps) => {
  const [isActive, setIsActive] = useState(false);
  const ref = useRef(null);
  useClickOutsideModalListener(ref, () => setIsActive(false));
  const authObject = useAuth();
  const { user } = authObject;
  const navigate = useNavigate();

  const displayName = () => {
    return (
      user?.displayName || user?.email?.split("@")[0] || "[No Name Available]"
    );
  };

  const getInitials = () => {
    if (user?.displayName) {
      return user.displayName.charAt(0);
    } else if (user?.email) {
      return user.email.charAt(0).toUpperCase();
    }
    return "?";
  };
  return (
    <Container
      ref={ref}
      isActive={isActive}
      isDrawerCollapsed={isDrawerCollapsed}
      className={isActive ? "active" : ""}
    >
      <Header>
        <MonogrammedDetailContainer
          isDrawerCollapsed={isDrawerCollapsed || isActive}
          type="button"
          onClick={() => setIsActive(true)}
        >
          <Monogram size={40}>{getInitials()}</Monogram>
          {(!isDrawerCollapsed || isActive) && (
            <DetailContainer isActive={isActive}>
              <NameLabel>{displayName()}</NameLabel>
              <EmailLabel>{user?.email}</EmailLabel>
            </DetailContainer>
          )}
        </MonogrammedDetailContainer>
        {(!isDrawerCollapsed || isActive) && (
          <ActionItem type="button" onClick={() => setIsActive(!isActive)}>
            {isActive ? <UnfoldIcon /> : <FoldIcon />}
          </ActionItem>
        )}
      </Header>
      {isActive && (
        <>
          <Divider />
          <Row to="#" onClick={async () => await authObject.logout()}>
            <RowIcon>
              <LogoutIcon />
            </RowIcon>
            <RowLabel>Sign out</RowLabel>
          </Row>
        </>
      )}
    </Container>
  );
};
